import { message } from 'antd';
import { client } from '../../../actions';
import { authHeader } from '../../../helpers/auth-header';

const setDocumentDefaultFilter = async (id) => {
  try {
    const data = { id, value: true };
    await client.put('/Filter/default', data, {
      headers: authHeader(),
      params: { type: 'DOCS' },
    });
  } catch (err) {
    message.error('Произошла ошибка при установке фильтра');
    console.error(err);
    return;
  }
};

export default setDocumentDefaultFilter;
